import { render, staticRenderFns } from "./SetCampaignModal.vue?vue&type=template&id=57b41982"
import script from "./SetCampaignModal.vue?vue&type=script&lang=js"
export * from "./SetCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports